/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_Kb6Inputs */

const en_mk_cmp_linear_kb6 = /** @type {(inputs: Mk_Cmp_Linear_Kb6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesian as the primary language.`)
};

const id_mk_cmp_linear_kb6 = /** @type {(inputs: Mk_Cmp_Linear_Kb6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia sebagai bahasa utama.`)
};

/**
* | output |
* | --- |
* | "Indonesian as the primary language." |
*
* @param {Mk_Cmp_Linear_Kb6Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_kb6 = /** @type {((inputs?: Mk_Cmp_Linear_Kb6Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_Kb6Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_kb6(inputs)
	return en_mk_cmp_linear_kb6(inputs)
});